"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ErrorMessageComponent_1 = __importDefault(require("./ErrorMessageComponent"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default(ErrorMessageComponent_1.default) `
    .error-code {
        margin: 0 10px;
    }

    .errorMessage {
        .redeem-redirect-link {
            font-size: 1em;
        }
    }
`;
//# sourceMappingURL=ErrorMessage.js.map